(function (kalitaView, $) {
  var kalitaSection;
  var kalitaSectionHeight;
  var kalitaSectionOffsetTop;

  var videoElement;
  var vimeoPlayer;
  var isVideoPaused = false;

  kalitaView.init = function () {
    kalitaSection = $("#kalita-section");

    var attributeExtension = el.window.width() < 768 ? "mobile" : "desktop";
    videoElement = $(".kalita-video");
    el.Utils.setVideoSrc(
      videoElement,
      videoElement.data("src-" + attributeExtension),
      videoElement.data("width-" + attributeExtension),
      videoElement.data("height-" + attributeExtension),
    );

    vimeoPlayer = new Vimeo.Player(videoElement[0]);

    calculateGeometry();
    setTimeout(calculateGeometry, 2000);
    setTimeout(calculateGeometry, 4000);
    setInterval(calculateGeometry, 7000);

    wireEvents();
  };

  function wireEvents() {
    el.documentElement.on("WINDOW_SCROLL_EVENT", function (evt, windowScrollTop) {
      var sectionOffset = windowScrollTop - kalitaSectionOffsetTop + el.windowHeight;

      if (sectionOffset < 0 || sectionOffset > kalitaSectionOffsetTop * 2 + 800) {
        return;
      }

      var offset = Math.max(0, sectionOffset);

      // For efficiency, pause the video when you go past it on the page
      var videoPauseThreshold = kalitaSectionHeight * 2 + 500;

      if (!isVideoPaused && offset > videoPauseThreshold) {
        isVideoPaused = true;
        vimeoPlayer.pause();
      } else if (isVideoPaused && offset < videoPauseThreshold) {
        isVideoPaused = false;
        vimeoPlayer.play();
      }
    });

    el.documentElement.on("WINDOW_RESIZED_EVENT", function () {
      calculateGeometry();
    });
  }

  function calculateGeometry() {
    kalitaSectionHeight = kalitaSection.height();
    kalitaSectionOffsetTop = kalitaSection.offset().top;
  }
})((window.el.KalitaView = window.el.KalitaView || {}), jQuery);
